import React, { useEffect, useState } from "react";
import TableOne from "../table/TableOne";
import { getRequest, deleteRequest } from "../api/api";
import {
  Modal,
  Form,
  Input,
  Upload,
  Button,
  Select,
  message,
  Switch,
} from "antd";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import "./../style/common.css";
import axios from "axios";
import { FaPlus } from "react-icons/fa6";
import { FaEdit } from "react-icons/fa";
import { GiBlackBook } from "react-icons/gi";
import ReactDOMServer from "react-dom/server";
import { FaTrash, FaTimes } from "react-icons/fa";

const SubModule = () => {
  const [subModules, setSubModules] = useState([]);
  const [modules, setModules] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editingSubModule, setEditingSubModule] = useState(null);
  // const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const getSubModules = async () => {
    setLoading(true);
    try {
      const response = await getRequest("submodules?all=true&isModule=true");
      setSubModules(response);
    } catch (error) {
      console.error("Error fetching submodules:", error);
    } finally {
      setLoading(false);
    }
  };

  const getModules = async () => {
    try {
      const response = await getRequest("modules?all=true");
      setModules(response);
    } catch (error) {
      console.error("Error fetching modules:", error);
    }
  };

  useEffect(() => {
    getSubModules();
    getModules();
  }, []);

  const handleDelete = async (subModule) => {
    const result = await Swal.fire({
      title: `Are you sure?`,
      html: `This will permanently delete <b>${subModule.name}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: ReactDOMServer.renderToString(
    <>
      <FaTrash style={{ marginRight: 6, verticalAlign: "middle" }} /> Yes, delete it!
    </>
  ),
  cancelButtonText: ReactDOMServer.renderToString(
    <>
      <FaTimes style={{ marginRight: 6, verticalAlign: "middle" }} /> Cancel
    </>
  ),
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      try {
        await deleteRequest(`submodules/${subModule.id}`);
        Swal.fire(
          "Deleted!",
          `"${subModule.name}" has been deleted.`,
          "success"
        );
        getSubModules();
      } catch (error) {
        console.error("Delete Error:", error);
        Swal.fire("Error", "Failed to delete the submodule.", "error");
      }
    }
  };

  const handleEdit = (subModule) => {
    setEditMode(true);
    // setLoading(true);
    setEditingSubModule(subModule);

    // const cleanedImageUrl = subModule.image_url?.replace(/\\/g, "") || "";

    form.setFieldsValue({
      module_id: subModule.module_id,
      name: subModule.name,
      description: subModule.description,
      is_active: subModule?.is_active === 1 || subModule?.is_active === "1",
      image: subModule.image
        ? [
            {
              uid: "-1",
              name: "Existing Image",
              status: "done",
              url: subModule.image, // 🟡 Image will be visible but not uploaded again
            },
          ]
        : [],
    });

    setModalVisible(true);
  };

  const handleAdd = () => {
    setEditMode(false);
    form.resetFields();
    setModalVisible(true);
  };

  const handleFormSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("module_id", values.module_id);
    formData.append("name", values.name);
    formData.append("description", values.description || "");
    const isActiveToSend = editMode ? (values?.is_active ? 1 : 0) : 1; // add default 1 on create
formData.append("is_active", isActiveToSend);


    // ✅ Use image from form values
    const imageFile = values.image?.[0]?.originFileObj;
    if (imageFile) {
      formData.append("image", imageFile);
    }

    const endpoint = editMode
      ? `https://pranafreshharvest.com/api/submodules/${editingSubModule.id}`
      : `https://pranafreshharvest.com/api/submodules`;

    const method = "post";
    const token = localStorage.getItem("token");

    try {
      const response = await axios({
        method,
        url: endpoint,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        message.success(
          `SubModule ${editMode ? "updated" : "added"} successfully`
        );
        setModalVisible(false);
        getSubModules();
      } else {
        message.error("Failed to save SubModule");
      }
    } catch (error) {
      message.error("Something went wrong");
      console.error("Axios error:", error.response || error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Sr. No.",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Image",
      key: "image",
      render: (_, record) => {
        const fallbackImage =
          "https://pranafreshharvest.com/profile_images/profile_20251108054906.png";
        const imageUrl = record.image || fallbackImage;
        return (
          <img
            src={imageUrl}
            alt="Submodule"
            width={40}
            height={40}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = fallbackImage;
            }}
          />
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Module",
      key: "module",
      render: (_, record) => record.module?.name || "N/A",
    },

    {
      title: "Status",
      key: "status",
      render: (_, record) => {
        const isActive = record.is_active === 1 || record.is_active === "1";
        return (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              color: isActive ? "#10b981" : "#ef4444",
              fontWeight: "500",
            }}
          >
            <span
              style={{
                height: "8px",
                width: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#10b981" : "#ef4444",
                display: "inline-block",
              }}
            />
            {isActive ? "Active" : "Inactive"}
          </span>
        );
      },
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <div className="header-button">
<h2
  style={{
    color: "#5a355a",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    lineHeight: 1,
  }}
>
  <GiBlackBook />
  <span>Sub Module</span>
  <span
    style={{
      color: "#979797ff",
      fontSize: "14px",
      fontWeight: 500,
      alignSelf: "flex-end", // bottom-align just the total
    }}
  >
    (Total: {subModules?.length ?? 0})
  </span>
</h2>
        <Button
          type="primary"
          onClick={handleAdd}
          icon={<PlusOutlined />}
          style={{ marginBottom: 20 }}
          className="add-btn"
        >
          Add Sub Module
        </Button>
      </div>

      <TableOne
        columns={columns}
        data={subModules}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
        loading={loading}
      />

      <Modal
        title={editMode ? "Update Sub Module" : "Add Sub Module"}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        destroyOnClose
        maskClosable={false}
      >
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Form.Item
            name="module_id"
            label="Module"
            rules={[{ required: true, message: "Select a Module Name" }]}
          >
            <Select
              showSearch
              placeholder="Select Module"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              style={{ width: "100%", borderRadius: 6 }}
              dropdownStyle={{ borderRadius: 6 }}
            >
              {modules.map((mod) => (
                <Select.Option key={mod.id} value={mod.id}>
                  {mod.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="name"
            label="SubModule Name"
            rules={[{ required: true, message: "Required Sub Module Name" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            // rules={[{ required: true, message: "Please enter a description" }]}
          >
            <Input.TextArea rows={6} style={{ minHeight: "120px" }} />
          </Form.Item>

          <Form.Item
            name="image"
            label="Image"
            valuePropName="fileList"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
          >
            <Upload
              listType="picture"
              maxCount={1}
              beforeUpload={() => false}
              accept="image/*"
            >
              <Button icon={<UploadOutlined />}>Upload Image</Button>
            </Upload>
          </Form.Item>
{editMode && (
  <Form.Item noStyle shouldUpdate>
    {({ getFieldValue }) => {
      const on = !!getFieldValue("is_active");
      return (
        <Form.Item
          name="is_active"
          label="Status"
          valuePropName="checked"
          className="custom-form-label"
        >
          <Switch
            checkedChildren="Active"
            unCheckedChildren="Inactive"
            className={`status-switch ${on ? "on" : "off"}`}
          />
        </Form.Item>
      );
    }}
  </Form.Item>
)}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
              icon={editMode ? <FaEdit /> : <FaPlus />}
            >
              {editMode ? "Update Sub Module" : "Add Sub Module"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default SubModule;
